<template>
  <v-container
    fluid
    class="white-background main-create-page mt-0"
    :class="[customClass]"
  >
    <div class="p-0 pb-0">
      <v-row>
        <v-col cols="12" md="12" class="pt-0" :class="headerLeftClass">
          <slot name="header-title"></slot>
        </v-col>
        <div
          class="pt text-center px-0 py-2"
          :class="headerRightClass"
          style="
            bottom: -5px;
            z-index: 6;
            background-color: #f4f4f4;
            max-width: calc(100% - 65px);
            position: fixed;
            width: 100%;
            right: 0px;
          "
        >
          <slot name="header-action"></slot>
        </div>
      </v-row>
    </div>
    <slot name="body"></slot>
    <slot name="barcode-setting"></slot>
    <slot name="extra"></slot>
    <template v-if="hasChanges">
      <!-- <PreventUnload :when="hasChanges" /> -->
    </template>
    <Dialog :commonDialog="routePreventDialog" :dialogWidth="500">
      <template v-slot:body>
        <div class="pa-2 d-flex align-center">
          <!-- Warning Icon -->
          <v-avatar color="red lighten-5" size="52" class="mr-4 flex-shrink-0">
            <v-icon size="32" color="red darken-2">
              mdi-alert-circle-outline
            </v-icon>
          </v-avatar>
          <!-- Content -->
          <div class="flex-grow-1 min-width-0">
            <h3 class="font-size-15 font-weight-700 color-custom-blue mb-2">
              Are you sure you want to leave this page?
            </h3>
            <div class="grey--text text--darken-1 font-size-12 mb-3">
              Any unsaved changes may be lost.
            </div>
            <!-- Actions -->
            <div class="d-flex align-center">
              <!-- Stay -->
              <v-btn
                depressed
                color="cyan darken-1"
                class="mr-2 custom-bold-button white--text"
                small
                v-on:click="stayOnPage"
              >
                <v-icon small left> mdi-shield-check-outline </v-icon> Stay on
                this page
              </v-btn>
              <!-- Leave -->
              <v-btn
                depressed
                color="grey lighten-4"
                class="custom-grey-border custom-bold-button grey--text text--darken-3"
                small
                v-on:click="leavePage"
              >
                <v-icon small left color="grey darken-2">
                  mdi-arrow-left-circle-outline
                </v-icon>
                Leave this page
              </v-btn>
            </div>
          </div>
        </div>
      </template>
    </Dialog>
  </v-container>
</template>

<script>
// import PreventUnload from "vue-prevent-unload";
import Dialog from "@/view/pages/partials/Dialog";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";

export default {
  props: {
    customClass: {
      type: String,
      default: null,
    },
    headerLeftClass: {
      type: String,
      default: null,
    },
    headerRightClass: {
      type: String,
      default: null,
    },
    routePreventDialog: {
      type: Boolean,
      default: false,
    },
    hasChanges: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    stayOnPage() {
      PreventDialogEventBus.$emit("stay-on-page", true);
    },
    leavePage() {
      PreventDialogEventBus.$emit("leave-page", true);
    },
  },
  components: {
    // PreventUnload,
    Dialog,
  },
};
</script>
